import React, { useState, useEffect } from 'react';
import './Navbar.css';

const links = [
  { id: 'hero',         label: 'Home' },
  { id: 'features',     label: 'Features' },
  { id: 'how-it-works', label: 'How It Works' },
  { id: 'detect',       label: 'Detect' },
  { id: 'diseases',     label: 'Diseases' },
  { id: 'blog',         label: 'Blog' },
  { id: 'feedback',     label: 'Reviews' },
  { id: 'about',        label: 'About' },
  { id: 'contact',      label: 'Contact' },
];

export default function Navbar({ activeSection }) {
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const go = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`navbar-cg ${scrolled ? 'scrolled' : ''}`}>
      <div className="container d-flex align-items-center justify-content-between">

        {/* Brand */}
        <button className="brand" onClick={() => go('hero')}>
          Crop<span>Guard</span> AI
        </button>

        {/* Toggler (mobile) */}
        <button
          className="navbar-toggler-cg d-lg-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`bi ${menuOpen ? 'bi-x-lg' : 'bi-list'}`}></i>
        </button>

        {/* Links */}
        <div className={`d-lg-flex align-items-center gap-1 ${menuOpen ? 'd-flex navbar-collapse-cg flex-column position-absolute top-100 start-0 end-0' : 'd-none'}`}>
          <ul className="d-flex flex-lg-row flex-column align-items-lg-center gap-1 list-unstyled mb-0">
            {links.map(l => (
              <li key={l.id}>
                <button
                  className={`nav-link-cg ${activeSection === l.id ? 'active' : ''}`}
                  onClick={() => go(l.id)}
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
          <button className="btn-nav-cta ms-lg-3 mt-2 mt-lg-0" onClick={() => go('detect')}>
            <i className="bi bi-camera me-1"></i> Try It Free
          </button>
        </div>

      </div>
    </nav>
  );
}
